var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"items":_vm.items,"value":_vm.value,"box":"","hide-details":""},on:{"input":(val) => _vm.$emit('input', val)}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }